/**
 * A V2 e o app unico do Nexus Food, servido na raiz.
 *
 * A calculadora publica (isca de aquisicao) continua sem login, em
 * `/calculadora`. Qualquer outro caminho carrega o app principal.
 */
import { isCalculadoraPath } from './entrypoint.js';

if (isCalculadoraPath(window.location.pathname)) {
  void import('./landing/calculadora.js');
} else {
  void import('./v2/main-v2.js');
}
